module.exports = __webpack_public_path__ + "static/media/broken-image.2fb133a3.png";